module.exports = "/_next/static/images/6753bf0681c7abe33e56430a07e603af-business-insider.png.webp";